import React from 'react'
import { spacing } from '@vacationtracker/shared/constants/ThemeSetting'

export interface RecordCardGridProps {
  /** Width a column aims for before the grid drops to fewer columns. A narrower container wins. */
  minWidth?: number
  children: React.ReactNode
}

export function RecordCardGrid({ minWidth = 320, children }: RecordCardGridProps) {
  return (
    <div
      style={{
        display: 'grid',
        // min() keeps the floor from outgrowing the container - a bare minmax() floor would push
        // the card past the right edge of a phone.
        gridTemplateColumns: `repeat(auto-fill, minmax(min(${minWidth}px, 100%), 1fr))`,
        gap: spacing.base,
        alignItems: 'start',
      }}
    >
      {children}
    </div>
  )
}

/** The same cards as a full-width list, one per row, for records read top to bottom. */
export function RecordCardList({ children }: { children: React.ReactNode }) {
  return <div style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>{children}</div>
}
